import { render, staticRenderFns } from "./ChangeDisableDelete.vue?vue&type=template&id=706d2906"
import script from "./ChangeDisableDelete.vue?vue&type=script&lang=js"
export * from "./ChangeDisableDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports